'use strict';

var React = require('react');

var SvgPageMinusMajor = function SvgPageMinusMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M11.379 0a1.5 1.5 0 0 1 1.06.44l4.122 4.12a1.5 1.5 0 0 1 .439 1.062v12.878a1.5 1.5 0 0 1-1.5 1.5h-11a1.5 1.5 0 0 1-1.5-1.5v-17a1.5 1.5 0 0 1 1.5-1.5h6.879zm-4.379 9a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2h-6z"
  }));
};

exports.SvgPageMinusMajor = SvgPageMinusMajor;
